import { render, staticRenderFns } from "./OrganizationInsightComponent.vue?vue&type=template&id=653392e9&"
import script from "./OrganizationInsightComponent.vue?vue&type=script&lang=ts&"
export * from "./OrganizationInsightComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports